import React from "react";
import "../styles/pop_up.css"; // Make sure to style it as needed

const Popup = ({ message, onConfirm }) => {
    return (
        <div className="popup-container">
            <div className="popup">
                <h3>{message}</h3>
                <button onClick={onConfirm}>OK</button>
            </div>
        </div>
    );
};

export default Popup;
